import makeStyles from '@material-ui/core/styles/makeStyles';
import React from 'react';

const useStyles = makeStyles({ root: { display: 'none' } });

const InputFile = (props) => <input type="file" className={useStyles().root} {...props} />;

export default InputFile;
